// import { TimelineMax } from 'gsap';
import {windowSize} from './windowSize';

let nomalScrollSet = {
  duration:1.1,
  ease:"Expo.easeOut",
  inview: $(".js-inviewSP"),
  whaleArea: $(".whale"),
  whaleTab:$(".m-menuSP"),
  isShow: "is-showSP",
  active: "is-active",
  posArray:[],
  inviewState:[],
  heightAdjustValue: 0.9,
};

export const nomalScroll={
  init:()=>{
    nomalScroll.stackItemsPosition();
    nomalScroll.scrollEvt();
  },
  scrollEvt:()=>{
    let setTimeoutId = null;
    window.addEventListener(
      'scroll',
      (e) => {
        if (setTimeoutId) clearTimeout(setTimeoutId);
        setTimeoutId = setTimeout(
          () => {
            nomalScroll.inviewHandle();
            nomalScroll.whaleTabHandle();
            setTimeoutId = null;
          }, 10
        );
      }
    );
  },
  whaleTabHandle:()=>{
    if(nomalScroll.position() >= nomalScrollSet.whaleArea.offset().top
      && nomalScroll.position() < nomalScrollSet.whaleArea.offset().top+nomalScrollSet.whaleArea.innerHeight() - 200){
        nomalScrollSet.whaleTab.addClass(nomalScrollSet.active);
    }
    else{
      nomalScrollSet.whaleTab.removeClass(nomalScrollSet.active);
    }
  },
  inviewHandle:()=>{
    for (let i=0,li=nomalScrollSet.posArray.length;i<li;i++) {
      let elTop=nomalScrollSet.posArray[i];
      if (nomalScroll.position() + windowSize.clientSize().H*nomalScrollSet.heightAdjustValue > elTop) {
        if (nomalScrollSet.inview.eq(i).hasClass(nomalScrollSet.isShow)) continue;
        nomalScrollSet.inview.eq(i).addClass(nomalScrollSet.isShow);
      }
    }
  },
  position:()=>{
    return document.documentElement.scrollTop || document.body.parentNode.scrollTop || document.body.scrollTop;
  },
  stackItemsPosition:()=>{
    for(let i=0,li=nomalScrollSet.inview.length;i<li;i++){
      nomalScrollSet.posArray.push(nomalScrollSet.inview.eq(i).offset().top);
    }
  },
};